import { render, staticRenderFns } from "./competency-card.vue?vue&type=template&id=cc296408&scoped=true"
import script from "./competency-card.ts?vue&type=script&lang=ts&external"
export * from "./competency-card.ts?vue&type=script&lang=ts&external"
import style0 from "./competency-card.scss?vue&type=style&index=0&id=cc296408&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc296408",
  null
  
)

export default component.exports